module.exports = __webpack_public_path__ + "static/media/ant.b05d3883.ogg";